export type FolderTreeItem = {
  id: string | number;
  name: string;
  children: FolderTreeItem[];
};

/**
 * Returns folder's full path from folder tree given its id
 * @param id of the folder
 * @param folderTree object
 * @returns path to the folder
 */
function getFullFolderPath(id: string | number, folderTree: FolderTreeItem) {
  const folderPaths: Record<string | number, string> = {};
  function createPaths(treeItem: FolderTreeItem, path: string) {
    if (!folderPaths[treeItem.id]) {
      folderPaths[treeItem.id] = path;
      treeItem.children.forEach((item) =>
        createPaths(item, `${path}/${item.name}`),
      );
    }
  }

  createPaths(folderTree, `${folderTree.name}`);
  return { [id]: folderPaths[id] };
}

/**
 * Validates folder path with regex
 * @param path string
 */
export function validateFolderPath(path: string) {
  const PATH_REGEX = /^[^/]+(\/[^/]+)+$/;
  return PATH_REGEX.test(path);
}

/**
 * Calculates path for a given folder by its id and nested folder structure
 * @param folderTree nested structure
 * @param folderId
 * @returns folder's path as a string
 */
export function getArchiveLocationPath(
  folderTree: FolderTreeItem | Record<string, never>,
  folderId: string | number,
) {
  return Object.values(folderTree).length
    ? getFullFolderPath(folderId, folderTree as FolderTreeItem)
    : null;
}
